import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getSortieEam = async (data) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/eam`, {
        params: {
            data
        }
    });
};

export const getSortieByEam = async (eam, part) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/by_smr_eam`, {
        params: {
            smr_ref: eam,
            part: part
        }
    });
};

export const putSortieEam = async (data) => {
    return userRequest.put(`${DOMAIN}/api/sortieEamFmp/put_eam`, data);
};

export const putSortieEamSmr = async (data) => {
    return userRequest.put(`${DOMAIN}/api/sortieEamFmp/put_eam_smr`, data);
};

export const getSortieFmp = async (data) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/fmp`, {
        params:{
            data
        }
    });
};

export const getSortieByFmp = async (item_code,smr) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/by_smr_fmp`, {
        params: {
            item_code,
            smr
        }
    });
};

export const putSortieFmp = async (data) => {
    return userRequest.put(`${DOMAIN}/api/sortieEamFmp/put_fmp`, data);
};

export const putSortieFmpSmr = async (data) => {
    return userRequest.put(`${DOMAIN}/api/sortieEamFmp/put_fmp_smr`, data);
};

export const getSmr = async () => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/smr`);
};

export const getPartItem = async () => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/part_item`);
};

export const getReconciliation = async (data) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/reconciliation`, {
        params: {
            data
        }
    });
};

export const getReconciliationItem = async (item, dateRange) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/itemCode`, {
        params: {
            item_code : item,
            dateRange
        }
    });
};

export const getReconGlobalItem = async (filters) => {
    return userRequest.get(`${DOMAIN}/api/sortieEamFmp/global_item`, {
        params : {
            filters
        }
    });
};

export const postDocPhysiqueEam = async (data) => {
    return userRequest.post(`${DOMAIN}/api/sortieEamFmp/eam_post`, data);
};

export const postDocPhysiqueFmp = async (data) => {
    return userRequest.post(`${DOMAIN}/api/sortieEamFmp/fmp_post`, data);
};